import React from 'react'

const SocialLink = ({ href, Icon }) => {
    return (
      <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center shrink-0 w-10 h-10 text-xs font-bold leading-none transition-all border border-black rounded-full hover:bg-white hover:border-white hover:shadow-tpmp"
    >
      <Icon className="w-auto h-5" />
    </a>
    )
}

export default SocialLink